import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "chevron-left-icon",
  "aria-label": "Chevron left icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.96967 12.5303C5.67678 12.2374 5.67678 11.7626 5.96967 11.4697L14.9697 2.46967C15.2626 2.17678 15.7374 2.17678 16.0303 2.46967C16.3232 2.76256 16.3232 3.23744 16.0303 3.53033L7.56066 12L16.0303 20.4697C16.3232 20.7626 16.3232 21.2374 16.0303 21.5303C15.7374 21.8232 15.2626 21.8232 14.9697 21.5303L5.96967 12.5303Z"
    }, null, -1)
  ])))
}
export default { render: render }